import css from './PendingAccess.module.css';
import * as authServices from '../../../services/authServices';

function PendingAccess({ user, onLogout }) {
    const handleLogout = async () => {
        try {
            await authServices.logout();
        } catch {
            // still clear local session
        }
        authServices.clearToken();
        onLogout();
    };

    return (
        <div className={css.container}>
            <div className={css.card}>
                <div className={css.logo}>
                    <img src="logo-white.png" alt="Plane Care Academy" />
                </div>
                <p className={css.message}>
                    Wait untill the administrator grant you access to the PCA CRM
                </p>
                {user?.userEmail && (
                    <p className={css.email}>Signed in as {user.userEmail}</p>
                )}
                <button type="button" className={css.button} onClick={handleLogout}>
                    Logout
                </button>
            </div>
        </div>
    );
}

export default PendingAccess;
